import React from "react";
import { TopToolbar, ExportButton, FilterButton } from "react-admin";
import { useMaxResultsByPlan } from "../../helpers/subscriptionPlan";

const ListActions = (props) => {
  const maxResults = useMaxResultsByPlan();

  return (
    <TopToolbar>
      <FilterButton />
      <ExportButton maxResults={maxResults} />
    </TopToolbar>
  );
};

export default ListActions;
